﻿window.cVerifAdresseEmail = function(bddRef, lstEmail, option) {
    if (typeof option == 'undefined') option = {}

    this.mExe = function () {
        if (bddRef.objCptCli.data.nb_credit_verif_adresse_email < lstEmail.length) {
            $("<div/>").appendTo("body").dxCtrlAchatPopup({
                bddCtrl: bddRef,
                typeProduit: "credit_test_adresse_email",
                nb: lstEmail.length,
                onPaiement: function () {
                    mInitBatchVerifEmail()
                },
                onValideReglementHorsCb: function () {
                    mNotify("Vous avez validé votre commande en différé. A réception de votre règlement, votre commande sera passée en facture et vos crédits vous seront attribués. Vous pourrez alors relancer la vérification de vos adresses emails et utiliser vos crédits.","success",30000)
                }
            })
        } else {
            mInitBatchVerifEmail()
        }
    }

    function mInitBatchVerifEmail() {
        jaugeDemarrage.mHide()
        var txtEmail = ""
        lstEmail.forEach(function (email) { txtEmail += ((txtEmail.length > 0) ? "," : "") + email.adresse_email })
        $("<div/>").appendTo("body").dxCtrlPopupVerifEmail({
            bddCtrl: bddRef,
            lstAdresseEmail: txtEmail,
            onClose: function () {
                if (typeof option.onClose != 'undefined') option.onClose()
            }
        })
    }
}